// Single source of truth for the backend URL. VITE_API_BASE_URL (includes the
// /api suffix) is the one canonical env var — everything else derives from it,
// instead of each file reading import.meta.env directly with its own fallback.
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3001/api';

// Base URL without the /api suffix, for non-REST uses (e.g. Socket.IO).
export const BACKEND_URL = API_BASE_URL.replace(/\/api\/?$/, '');

// Master switch for the AI chat UI (self-hosted model shelved). Read here —
// in the always-bundled main chunk, not inside ChatBubble.tsx itself — so
// App.tsx can skip even requesting the lazy chunk while it's off, instead of
// downloading it just to have it immediately render null.
export const AI_UI_ENABLED = false;
